import { render, staticRenderFns } from "./TextInColumns.vue?vue&type=template&id=761788ce"
import script from "./TextInColumns.vue?vue&type=script&lang=js"
export * from "./TextInColumns.vue?vue&type=script&lang=js"
import style0 from "./TextInColumns.vue?vue&type=style&index=0&id=761788ce&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports